<template>
	<v-container grid-list-md class="pa-0">
		<v-card>
			<v-card-text>
				<v-layout row wrap>
					<v-flex xs12 md6>
						<ValidationProvider
							name="adults"
							rules="required"
							v-slot="{ errors, valid }"
						>
							<v-text-field
								type="number"
								label="Adults"
								v-model="item.adults"
								prepend-icon="mdi-human-male-female"
								min="1"
								data-vv-name="adults"
								:error-messages="errors"
								class="required"
							></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12 md6>
						<ValidationProvider
							name="children"
							rules="required"
							v-slot="{ errors, valid }"
						>
							<v-text-field
								type="number"
								label="Children"
								v-model="item.children"
								prepend-icon="mdi-human-child"
								min="0"
								data-vv-name="children"
								:error-messages="errors"
								class="required"
							></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12 md6>
						<ValidationProvider
							name="date"
							rules="required"
							v-slot="{ errors, valid }"
						>
							<v-menu
								v-model="menu1"
								:close-on-content-click="false"
								max-width="290"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										:value="computedDateFormattedMomentjs"
										label="Date"
										readonly
										v-bind="attrs"
										v-on="on"
										@click:clear="item.date = null"
										prepend-icon="mdi-calendar"
										data-vv-name="date"
										:error-messages="errors"
										class="required"
									></v-text-field>
								</template>
								<v-date-picker
									v-model="item.date"
									@change="menu1 = false"
									:min="today"
								></v-date-picker>
							</v-menu>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12 md6>
						<ValidationProvider
							name="time"
							rules="required"
							v-slot="{ errors, valid }"
						>
							<v-autocomplete
								label="Time"
								:items="times"
								v-model="item.time"
								prepend-icon="mdi-clock"
								data-vv-name="reservation.time"
								:error-messages="errors"
								class="required"
							>
							</v-autocomplete>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12>
						<ValidationProvider
							name="description"
							rules=""
							v-slot="{ errors, valid }"
						>
							<v-textarea
								v-model="item.description"
								label="Description"
								prepend-icon="mdi-comment"
								:error-messages="errors"
							>
							</v-textarea>
						</ValidationProvider>
					</v-flex>
				</v-layout>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
import moment from "moment";
import { format, parseISO } from "date-fns";
export default {
	props: ["value"],
	data() {
		return {
			today: format(parseISO(new Date().toISOString()), "yyyy-MM-dd"),
			menu1: false,
			titles: ["Mr.", "Ms.", "Mrs.", "Mdm.", "Dr."],
			times: [],
		};
	},
	computed: {
		item: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
		computedDateFormattedMomentjs() {
			return this.item.date
				? moment(this.item.date).format("dddd, MMMM Do YYYY")
				: "";
		},
	},
	watch: {
		"item.date": {
			async handler() {
				if (this.item.date) {
					await this.getReservationShift();
				}
			},
			immediate: true,
		},
	},
	methods: {
		async getReservationShift() {
			try {
				const response = await axios.get(
					this.$route(
						"reservation.times",
						this.$route().params.outlet
					),
					{
						params: {
							date: this.item.date,
						},
					}
				);
				if (response.data.success) {
					this.item.time = null;
					this.times = response.data.data;
				} else {
					this.$toast.error(response.data.data);
				}
			} catch (error) {
				this.$toast.error(error.message);
			}
		},
	},
};
</script>